import { UserModel } from "./../../domaine/userModel";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AuthData, login } from "../../api/auth.api";
import {
  deleteProjectID,
  deleteToken,
  deleteUser,
  persistToken,
  readToken,
  readUser,
} from "../../services/localStorage.Service";
import { setUser } from "./userSlice";

interface AuthState {
  user: UserModel | null;
  token: string | null;
  isAuthenticated: boolean;
  loading: "idle" | "pending" | "succeeded" | "failed";
}

const initialState: AuthState = {
  isAuthenticated: !!readToken(),
  user: readUser(),
  token: readToken(),
  loading: "idle",
};
export const doLogout = createAsyncThunk(
  "auth/doLogout",
  async (_, { dispatch }) => {
    deleteToken();
    deleteUser();
    deleteProjectID();
    dispatch(setUser(null));
  }
);

export const doLogin = createAsyncThunk(
  "auth/doLogin",
  async (loginPayload: AuthData, { dispatch, rejectWithValue }) => {
    try {
      const res = await login(loginPayload, "login/");
      dispatch(setUser(res.user));
      persistToken(res.access);
      return { token: res.access, user: res.user };
    } catch (error: any) {
      // Handle login error
      console.error("Login failed", error);

      dispatch(setUser(null));
      deleteToken();
      return rejectWithValue(error.response?.data || "Login failed");
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // login: (state, action: PayloadAction<{ token: string; user: User }>) => {
    //   state.token = action.payload.token;
    //   state.user = action.payload.user;
    //   state.isAuthenticated = true;
    // },
    // logout: (state) => {
    //   state.token = null;
    //   state.user = null;
    //   state.isAuthenticated = false;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(doLogin.pending, (state) => {
        state.loading = "pending";
      })
      .addCase(doLogin.fulfilled, (state, action) => {
        state.token = action.payload.token;
        state.user = action.payload.user;
        state.isAuthenticated = true;
        state.loading = "succeeded";
      })
      .addCase(doLogin.rejected, (state) => {
        state.loading = "failed";
      })
      .addCase(doLogout.fulfilled, (state) => {
        state.token = null;
        state.user = null;
        state.isAuthenticated = false;
      });
  },
});

// export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
